import LayoutDashboard from './LayoutDashboard';

export default LayoutDashboard;
